import React from 'react';

const Footer = () => (
	<footer>
		<h5>pirrotta.giusy@gmail.com</h5>
		<p>Copyright © 2020 Giusy Pirrotta</p>
	</footer>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js